module.exports = __webpack_public_path__ + "static/media/Replayer_community_sportivi.d9e9ae3c.jpg";